import { supabase } from "../supabaseClient";
import { getAdminUser } from "./adminAuth";

export const createAdminNotification = async ({ title, message = "", meta = "Admin", scope = "admin" }) => {
  const payload = {
    title: String(title || "Notification"),
    message: String(message || ""),
    meta: String(meta || "Admin"),
    scope: String(scope || "admin"),
    is_read: false,
  };

  const user = await getAdminUser();
  const userId = user?.id;
  if (userId) {
    payload.created_by = userId;
  }

  const { error } = await supabase.from("notifications").insert(payload);
  if (error) {
    // Keep UI actions non-blocking if notification insert fails.
    console.error("Failed to create admin notification:", error);
  }
};
